<template>
  <div class="sidebar" :class="{ active: isActive }">
    <header>
      <router-link :to="{ name: 'report' }">
        <img :src="getLogoUrl(teamLogo)" class="logo" />
      </router-link>
    </header>

    <!-- User Name Here -->
    <div class="username-holder">
      <h2 class="uppercase">{{ userName }}</h2>
    </div>

    <ul class="sidebar-menu">
      <router-link
        tag="li"
        v-for="menu of sideBarMenu"
        :key="menu.title"
        :to="menu.route"
        active-class="active"
        v-on:click.native="closeSideBarAutomatically"
      >
        <span @click="expandSubmenu(menu.menuId)">{{ menu.title }}</span>
        <ul
          class="submenus"
          :class="{
            'hidden-submenus': menu.hiddenSubmenu,
            'expand-submenus': !menu.hiddenSubmenu
          }"
        >
          <router-link
            tag="li"
            v-for="(submenu, i) of menu.submenus"
            :key="submenu.title"
            :to="submenu.route"
            :class="{ 'is-last': menu.submenus.length - 1 === i }"
          >
            <p>{{ submenu.title }}</p>
          </router-link>
        </ul>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import LogoRender from '@/mixins/Util'
export default {
  name: 'Sidebar',
  mixins: [LogoRender],
  data: function() {
    return {
      currentWindowSize: null
    }
  },
  created() {
    window.addEventListener('resize', this.checkIfSideBarIsActive)
  },
  destroyed() {
    window.removeEventListener('resize', this.checkIfSideBarIsActive)
  },
  methods: {
    checkIfSideBarIsActive(e) {
      if (!this.isActive && e.target.innerWidth < 1200) {
        this.$store.dispatch('globalTracking/displaySideBar')
      }
      this.currentWindowSize = e.target.innerWidth
    },
    closeSideBarAutomatically() {
      if (this.sideBarMenu && this.currentWindowSize < 1200) {
        this.$store.dispatch('globalTracking/displaySideBar')
      }
    },
    expandSubmenu(menuId) {
      // find current open submenu
      let currentOpenMenu = this.sideBarMenu.find(menu => !menu.hiddenSubmenu)
      let menuIndex = this.sideBarMenu.findIndex(menu => menu.menuId === menuId)
      if (currentOpenMenu) {
        if (currentOpenMenu.menuId === this.sideBarMenu[menuIndex].menuId) {
          // toggle show / hide menu not used for now
          // this.sideBarMenu[menuIndex].hiddenSubmenu = !this.sideBarMenu[
          //   menuIndex
          // ].hiddenSubmenu
        } else {
          // clicked different menu so hidde all and then expand the one the user clicked
          for (let index = 0; index < this.sideBarMenu.length; index++) {
            this.sideBarMenu[index].hiddenSubmenu = true
          }

          this.sideBarMenu[menuIndex].hiddenSubmenu = !this.sideBarMenu[
            menuIndex
          ].hiddenSubmenu
        }
      } else {
        // toggle show / hide menu
        this.sideBarMenu[menuIndex].hiddenSubmenu = !this.sideBarMenu[menuIndex]
          .hiddenSubmenu
      }
    }
  },
  computed: {
    userName() {
      return Object.entries(this.user).length
        ? this.user.fullName
        : this.user.email
    },
    user() {
      return this.$store.getters['profile/user']
    },
    ...mapState({
      isActive: state => state.globalTracking.isActive,
      teamLogo: state => state.team.team.teamLogo.url
    }),
    ...mapGetters({
      sideBarMenu: 'sideBar/getSideBarMenu'
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.sidebar {
  padding-bottom: 12rem;
  font-family: $editorial;
  position: fixed;
  overflow: auto;
  transition: 1s ease-in;
  -webkit-transition: all 0.25s;
  background: $main-white;
  width: 283px;
  height: 100%;
  z-index: 999;
  top: 0;
  left: 60px;

  header {
    background: $main-white;
    display: flex;
    /* justify-content: center; */
    padding: 2.75rem 0;
    img {
      height: 4rem;
    }
  }
}

.sidebar::-webkit-scrollbar {
  width: 1px;
}

.sidebar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px inherit;
  border-radius: 10px;
}

.sidebar::-webkit-scrollbar-thumb {
  background: inherit;
  border-radius: 10px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: inherit;
}

.username-holder {
  text-align: left;
  padding: 1.5rem 1rem;
  border: 1px solid $onyx;
  background: $onyx;

  h2 {
    font-size: 2.25rem;
    color: $main-white;
    font-family: $editorial;
    font-weight: 300;
    line-height: 48px;
  }
}

.active {
  left: 60px;
  transition: 1s ease-in;
}

.sidebar .sidebar-menu {
  list-style: none;
  display: flex;
  justify-content: center;
  padding: 0;
  flex-direction: column;
  border: 1px solid $onyx;
  border-bottom: none !important;
}

.sidebar .sidebar-menu li {
  display: block;
  justify-content: flex-start;
  border-bottom: 1px solid $onyx;
  list-style-type: none;
  text-align: left;
}

.sidebar .sidebar-menu li.active {
  /* border-left: 4px solid $main-white; */
}

.sidebar .sidebar-menu li span {
  padding: 0.75rem 1rem;
  color: $onyx;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-decoration: none;
  box-sizing: border-box;
  color: $onyx;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: 300;
  transition: 0.4s;

  &:hover {
    padding-left: 10px;
  }

  img {
    display: none;
    width: 1.1rem;
  }
}

.sidebar .sidebar-menu li a .svg-inline--fa {
  width: 30px;
}

.divider {
  border-bottom: 1px solid $main-4;
  margin-left: 28%;
  margin-right: 25%;
  margin-top: 1em;
  margin-bottom: 2.5rem;
  border-radius: 5px;
  border-left: 0 !important;
}

// Submenus

.sidebar .submenus li {
  background: $onyx;
  display: flex;
  align-items: center;
  list-style-type: none;
  text-align: left;
  color: #f5f2ef;
  padding: 1.25rem 2.5rem;
  border-bottom: 1px solid $main-white;
  height: 2rem;
  overflow: hidden;

  &.is-last {
    border-bottom: none;
  }
}

.sidebar .submenus li p {
  text-transform: uppercase;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-decoration: none;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 0.8rem;
  transition: 0.4s;
  font-family: $inter;
  font-weight: 300;

  &:hover {
    padding-left: 10px;
  }

  img {
    display: none;
    width: 1.1rem;
  }
}

.hidden-submenus {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.6s ease;
}

.expand-submenus {
  max-height: 100vh;
  overflow: hidden;
  transition: max-height 1.5s ease;
}

@media (max-width: 1200px) {
  .sidebar {
    left: 0px;
    padding-top: 3rem;
  }
}
@media (max-width: 1200px) {
  .active {
    left: -300px;
    transition: 0.3s ease-in;
  }
}

@media (min-width: 1200px) {
  .sidebar {
    z-index: 2;
  }
}
</style>
